import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@htx/environment';

export const XauthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.oauth || !req.url.includes(environment.oauth.issuer)) {
    const apiKey = (environment as Record<string, unknown>)['apiKey'];
    const apiToken = typeof apiKey === 'string' ? apiKey : 'password';

    const clonedRequest = req.clone({
      setHeaders: {
        'X-Api-Key': apiToken
      },
      withCredentials: true
    });

    return next(clonedRequest);
  }

  return next(req);
};
